import {LoadingOverlay as MantineLoadingOverlay} from '@mantine/core';

/**
 * Loading overlay over a relatively-positioned parent — design-layer pass-through over Mantine `LoadingOverlay`.
 * @registry Pass-through Mantine LoadingOverlay; import this instead of @mantine/core outside src/design.
 */
export const LoadingOverlay = MantineLoadingOverlay;
